import { withTranslation } from 'react-i18next';
import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';

class SizeLength extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			redirect: false,
			length: 0,
			weight: 0,
		};

		this.handleAgeWeight = this.handleAgeWeight.bind(this);
		this.handleChangeLength = this.handleChangeLength.bind(this);
		this.handleChangeWeight = this.handleChangeWeight.bind(this);
		this.skipBtn = this.skipBtn.bind(this);
		this.goBack = this.goBack.bind(this);
	}

	componentDidMount() {
		window.scrollTo(0, 0);

		if (this.props.weight) {
			this.setState({weight: this.props.weight});
		}
		if (this.props.length) {
			this.setState({length: this.props.length});
		}
	}

	render() {

		if(this.state.redirect) {
			return <Redirect to='/advice/price'/>;
		}

		return(


				<form className="sizes" onSubmit={this.handleAgeWeight}>
					<div className="row justify-content-center">
						<div className="col-12 text-center title">

							<h2>{this.props.t('Wat zijn jouw lichaamsmaten?')}</h2>
							 <span className="sub-title">{this.props.t('sizeLength-Sub-title')}.</span>

						</div>
						<div className="col-sm-6 center-text">

								<div className="row">
									<div className="col-sm-12">
										<div className="shadow-column">
											<img className="sizes-img img-responsive" src="/img/silhouette/body_1.png" alt="opmeten lengte"/>
										</div>
									</div>

								</div>


						</div>
						<div className="col-sm-6">
							<div className="row justify-content-center">

								<div className="col-12">

										<div className="row text-center">
											<div className="col-sm-12 margin-bottom">
												<div className="shadow-column padding32">
													<h3>{this.props.t('Hoe lang ben je?')}</h3>
													<div className="input-group mb-3">
													<input id="length" className="form-control" name="length" type="number" min="120" max="220" step="0.1" defaultValue={this.state.length ? this.state.length / 10 : ''} onChange={this.handleChangeLength} />
													<div className="input-group-append">
															<span className="input-group-text" id="basic-addon2">CM</span>
														</div>
													</div>
												</div>
											</div>
											<div className="col-sm-12">
												<div className="shadow-column padding32">
													<h3>{this.props.t('Hoeveel weeg je?')}</h3>
													<div className="input-group mb-3">
														<select className="form-control" onChange={this.handleChangeWeight} >
														  <option name="weight" value="0_50" selected={this.state.weight === '0_50' ? 'selected' : ''}>{this.props.t('0-50')}</option>
														  <option name="weight" value="50_70" selected={this.state.weight === '50_70' ? 'selected' : ''}>{this.props.t('50-70')}</option>
														  <option name="weight" value="70_90" selected={this.state.weight === '70_90' ? 'selected' : ''}>{this.props.t('70-90')}</option>
														  <option name="weight" value="90_100" selected={this.state.weight === '90_100' ? 'selected' : ''}>{this.props.t('90-100')}</option>
														  <option name="weight" value="100+" selected={this.state.weight === '100+' ? 'selected' : ''}>{this.props.t('100+')}</option>
														</select>

														<div className="input-group-append">
															<span className="input-group-text" id="basic-addon2">{this.props.t('KG')}</span>
														</div>
													</div>
												</div>
											</div>

									</div>
								</div>


							</div>
						</div>
					</div>
					<div className="row form-buttons">


						<div className="col-6 text-left">
							<button type="button" className="back btn btn-link" onClick={this.goBack}><i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
						</div>
						<div className="col-6 text-right">
							<button type="button" id="skipbtn" className="btn btn-secondary" onClick={this.skipBtn}>{this.props.t('Sla over')}</button>
							<input id="submitbtn" className="btn btn-secondary" type="submit" value={this.props.t('Volgende')} />
						</div>

					</div>
				</form>




		);

	}

	handleChangeWeight(event) {
		this.setState({weight: event.target.value});
	}
	handleChangeLength(event) {
		this.setState({length: event.target.value * 10});
	}
	handleAgeWeight(event) {
		event.preventDefault();
		if(this.state.length) {
			this.props.handleSubmit(this.state.length, this.state.weight);
		} else {
			alert('vul uw lengte in');
		}
	}
	goBack(event) {
		event.preventDefault();
		this.props.back();
	}
	skipBtn(e) {
		e.preventDefault();
		this.props.nextAdviceStep();
	}
}

export default withTranslation('sizesBody')(SizeLength);
